import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { MediaMonitoringOverviewPageBg } from "@/components/site/MediaMonitoringOverviewPageBg";
import { MEDIA_MONITORING_META_DESCRIPTION_BG } from "@/content/meta/MediaMonitoringOverviewPageBg";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/bg/media-monitoring/")({
  head: () => ({
    meta: [
      { title: "Услуги за медиен мониторинг в Югоизточна Европа | Perceptica" },
      { name: "description", content: MEDIA_MONITORING_META_DESCRIPTION_BG },

      { property: "og:title", content: "Услуги за медиен мониторинг в Югоизточна Европа | Perceptica" },
      { property: "og:description", content: MEDIA_MONITORING_META_DESCRIPTION_BG },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Услуги за медиен мониторинг в Югоизточна Европа | Perceptica" },
      { name: "twitter:description", content: MEDIA_MONITORING_META_DESCRIPTION_BG },
      { property: "og:url", content: "https://perceptica.com/bg/media-monitoring" },
      ...ogImageMeta("bg", "/media-monitoring"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/media-monitoring/index", service: { name: "Медиен мониторинг", description: "Услуги за медиен мониторинг от Perceptica в Югоизточна Европа.", serviceType: "Медиен мониторинг" } }),
  }),
  component: MediaMonitoringOverviewPageBg,
});
